<script setup lang="ts">
import { useSnackbarStore } from '@/stores/snackbar';
import { InfoCircleIcon, CircleCheckIcon, AlertCircleIcon, XIcon } from 'vue-tabler-icons';
import { computed } from 'vue';

const snackbarStore = useSnackbarStore();

const icon = computed(() => {
  switch (snackbarStore.type) {
    case 'success':
      return CircleCheckIcon;
    case 'error':
      return AlertCircleIcon;
    case 'warning':
      return AlertCircleIcon;
    case 'info':
      return InfoCircleIcon;
    default:
      return InfoCircleIcon;
  }
});
</script>

<template>
  <v-snackbar
    v-model="snackbarStore.show"
    :timeout="snackbarStore.timeout"
    :location="snackbarStore.location"
    :color="snackbarStore.color"
    rounded="md"
    elevation="0"
    class="mt-10"
  >
    <div class="d-flex gap-2 align-center">
      <component :is="icon" size="22" />
      <div class="flex-grow-1">
        <h5 v-if="snackbarStore.title" class="text-body-1 mb-1">
          {{ snackbarStore.title }}
        </h5>
        <p class="text-body-2 ma-0">
          {{ snackbarStore.text }}
        </p>
      </div>
    </div>
    <template v-slot:actions>
      <v-btn variant="text" @click="snackbarStore.hideSnackbar">
        <XIcon />
      </v-btn>
    </template>
  </v-snackbar>
</template>
